import {
  XING_ONBOARDING_PATH,
  XING_PROFILE_PATH,
} from '@xing-com/crate-core-routes';

// Profile Main Route
export const ROUTE_PROFILE = XING_PROFILE_PATH;
export const getProfileRouteWithId = ({
  profileId,
  searchParams = '',
  tab,
}: {
  profileId: string;
  searchParams?: string;
  tab?: string;
}): string =>
  `${XING_PROFILE_PATH}/${encodeURIComponent(profileId)}${tab ? `/${encodeURIComponent(tab)}` : ''}${searchParams}`;

// Profile-preview Route
export const ROUTE_PROFILE_PREVIEW = '/profile-preview';

// LinkedIn Signup OAuth Routes
export const ROUTE_LINKEDIN_SIGNUP_ONBOARDING =
  '/signup/oauth/linkedin?caller=onboarding';
export const ROUTE_LINKEDIN_SIGNUP_PROFILE =
  '/signup/oauth/linkedin?caller=profile';

// LinkedIn Data Import Routes
export const ROUTE_PROFILE_LINKEDIN_DATA_IMPORT_START =
  XING_PROFILE_PATH + '?data_import=true';
export const ROUTE_PROFILE_LINKEDIN_DATA_IMPORT_CALLBACK_ERROR =
  XING_PROFILE_PATH + '?data_import=true&callback=error';
export const ROUTE_PROFILE_LINKEDIN_DATA_IMPORT_CALLBACK_SUCCESS =
  XING_PROFILE_PATH + '?data_import=true&callback=success';
export const ROUTE_PROFILE_LINKEDIN_DATA_IMPORT_UP_TO_DATE =
  XING_PROFILE_PATH + '?up2date';

export const ROUTE_ONBOARDING_LINKEDIN_DATA_IMPORT_CALLBACK_ERROR =
  XING_ONBOARDING_PATH + '?callback=error&dest_url=' + XING_PROFILE_PATH;
export const ROUTE_ONBOARDING_LINKEDIN_DATA_IMPORT_CALLBACK_SUCCESS =
  XING_ONBOARDING_PATH + '?callback=success&dest_url=' + XING_PROFILE_PATH;

// Linkedin-auth callback routes with referrer query param to determine where to navigate after BE processes the user's LinkedIn data
const ROUTE_PROFILE_LINKEDIN_AUTH_DATA_IMPORTS = '/data_imports/linkedin';
export const ROUTE_PROFILE_LINKEDIN_AUTH_DATA_IMPORTS_CALLBACK_SUCCESS_PROFILE =
  ROUTE_PROFILE_LINKEDIN_AUTH_DATA_IMPORTS + '?callback=success&caller=profile';
export const ROUTE_PROFILE_LINKEDIN_AUTH_DATA_IMPORTS_CALLBACK_ERROR_PROFILE =
  ROUTE_PROFILE_LINKEDIN_AUTH_DATA_IMPORTS + '?callback=error&caller=profile';
export const ROUTE_PROFILE_LINKEDIN_AUTH_DATA_IMPORTS_CALLBACK_SUCCESS_ONBOARDING =
  ROUTE_PROFILE_LINKEDIN_AUTH_DATA_IMPORTS +
  '?callback=success&caller=onboarding';
export const ROUTE_PROFILE_LINKEDIN_AUTH_DATA_IMPORTS_CALLBACK_ERROR_ONBOARDING =
  ROUTE_PROFILE_LINKEDIN_AUTH_DATA_IMPORTS +
  '?callback=error&caller=onboarding';

export const ROUTE_PROFILE_CV_UPDATE_EDIT =
  '/profile/my_profile/cv-update/edit';

// About Me Module Routes
export const ROUTE_ABOUT_ME_EDIT =
  XING_PROFILE_PATH + '/my_profile/about-me/edit';

// Hobbies and Interests Module Routes
export const ROUTE_EDIT_INTERESTS =
  XING_PROFILE_PATH + '/my_profile/interests/edit';

// Business Card Module Routes
export const ROUTE_BC_CONTACT_DETAILS_EDIT =
  XING_PROFILE_PATH + '/my_profile/xing-id/contact-details/edit';
export const ROUTE_BC_CONTACT_DETAILS_EDIT_BUSINESS =
  XING_PROFILE_PATH + '/my_profile/xing-id/contact-details/edit/business';
export const ROUTE_BC_CONTACT_DETAILS_EDIT_PRIVATE =
  XING_PROFILE_PATH + '/my_profile/xing-id/contact-details/edit/private';
export const ROUTE_BC_COVER_IMAGE_EDIT =
  XING_PROFILE_PATH + '/my_profile/xing-id/cover-image/edit';
export const ROUTE_BC_HIRING_EDIT =
  XING_PROFILE_PATH + '/my_profile/hiring-details/edit';
export const ROUTE_BC_PERSONAL_DETAILS_EDIT =
  XING_PROFILE_PATH + '/my_profile/personal-details/edit';
export const ROUTE_BC_PROFILE_IMAGE_DELETE =
  XING_PROFILE_PATH + '/my_profile/xing-id/profile-image/delete';
export const ROUTE_BC_PROFILE_IMAGE_EDIT =
  XING_PROFILE_PATH + '/my_profile/xing-id/profile-image/edit';
export const ROUTE_BC_OCCUPATION_EDIT =
  XING_PROFILE_PATH + '/my_profile/xing-id/occupations/edit';
export const ROUTE_BC_STATUS_MESSAGE_EDIT =
  XING_PROFILE_PATH + '/my_profile/xing-id/status-message/edit';
export const getContactDetailsRoute = (profileId: string): string =>
  `${XING_PROFILE_PATH}/${profileId}/xing-id/contact-details`;

// Skills Module Routes
export const ROUTE_SKILLS_ADD = XING_PROFILE_PATH + '/my_profile/skills/add';
export const ROUTE_SKILLS_EDIT = XING_PROFILE_PATH + '/my_profile/skills/edit';
export const ROUTE_SKILLS_PERFORMANCE =
  XING_PROFILE_PATH + '/my_profile/skills/performance';
// for @xing-com/link which does not support relative links
export const ROUTE_SKILLS_BASEPATH = XING_PROFILE_PATH + '/my_profile/skills';
export const ROUTE_SKILLS_ADD_SHORT = '/add';
export const ROUTE_SKILLS_EDIT_SHORT = '/edit';
export const ROUTE_SKILLS_PERFORMANCE_SHORT = '/performance';

// Languages Module Routes
export const ROUTE_LANGUAGES_EDIT =
  XING_PROFILE_PATH + '/my_profile/languages/edit';

// Legal Notice Module Routes
export const ROUTE_LEGAL_INFORMATION_EDIT =
  XING_PROFILE_PATH + '/my_profile/legal-information/edit';
export const getShowLegalInformationUrl = (profileId: string): string =>
  `${XING_PROFILE_PATH}/${encodeURIComponent(profileId)}/legal-information/show`;

// Timeline Module Routes
export const ROUTE_TIMELINE_ADD =
  XING_PROFILE_PATH + '/my_profile/timeline/add';
export const ROUTE_TIMELINE_ADD_EMPLOYEE =
  XING_PROFILE_PATH + '/my_profile/timeline/add/employee';
export const ROUTE_TIMELINE_ADD_UNIVERSITY_STUDENT =
  XING_PROFILE_PATH + '/my_profile/timeline/add/university_student';
export const ROUTE_TIMELINE_EDIT =
  XING_PROFILE_PATH + '/my_profile/timeline/edit';
const ROUTE_TIMELINE_SHOW = XING_PROFILE_PATH + '/my_profile/timeline/show';
export const getTimelineShowRoute = (profileId: string, urn: string): string =>
  `${ROUTE_TIMELINE_SHOW}/${encodeURIComponent(profileId)}/${urn}`;

// Visibility Settings (ModuleStore) Routes
export const ROUTE_VISIBILITY_SETTINGS =
  XING_PROFILE_PATH + '/my_profile/module-store/edit';
